export const DYNAMIC_CONTENTS_LIST = 'DYNAMIC_CONTENTS_LIST';
export const DYNAMIC_CONTENT_VIEW = 'DYNAMIC_CONTENT_VIEW';
export const DYNAMIC_CONTENT_ADD = 'DYNAMIC_CONTENT_ADD';
export const DYNAMIC_CONTENT_EDIT = 'DYNAMIC_CONTENT_EDIT';
